import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

interface Biotemplate {
  id: number;
  biofuel_type: string;
  raw_material_origin: string;
  fuel_type: string;
  raw_material: string;
  double_counted_norway: string;
  reduction_in_climate_emission: number;
  storage_terminal: string;
  available_quantity: number;
  allocated_quantity: number;
  allocated_eq_quantity: number;
}

interface AllocationResponse {
  valid: boolean;
  delivered_quantities?: any;
  biotemplates?: Biotemplate[];
  offroad_biotemplates?: {
    general: Biotemplate[];
    reserved: Biotemplate[];
    joint: Biotemplate[];
    additional: Biotemplate[];
    notApplicable: Biotemplate[];
    generalAllocationNotNeeded: boolean;
  };
  surplus_biotemplates?: any;
  sustainability_quantities?: any;
  message?: any;
}

const startAllocation = async (mandate:string): Promise<AllocationResponse> => {
  const token = getToken();
  let valid = false;
  let result;
  const mandate_type = mandate;

  if (token) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/sustainability_reports/allocate_storages?mandate=${mandate_type}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      result = await response.json();

      valid =
        result &&
        result.success &&
        result.delivered_quantities &&
        result.biotemplates &&
        result.offroad_biotemplates &&
        result.surplus_biotemplates &&
        result.sustainability_quantities;
    } catch (except) {
      valid = false;
    }
  }

  if (!valid) {
    if (result && result.errors) {
      return {
        valid: false,
        message: result.errors,
      };
    }
    return {
      valid: false,
      message: "Something unexpected happened",
    };
  }

  return {
    valid: true,
    delivered_quantities: result.delivered_quantities,
    biotemplates: result.biotemplates,
    offroad_biotemplates: result.offroad_biotemplates,
    surplus_biotemplates: result.surplus_biotemplates,
    sustainability_quantities: result.sustainability_quantities,
  };
};

export default startAllocation;
